module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverflow"
  }, [_c('carousel-3d', {
    ref: "carousel",
    attrs: {
      "height": 300
    },
    on: {
      "after-slide-change": _vm.onAfterSlideChange
    }
  }, _vm._l((_vm.images), function(image, $index) {
    return _c('slide', {
      attrs: {
        "index": $index
      }
    }, [_c('img', {
      key: $index,
      attrs: {
        "src": image.src
      },
      on: {
        "click": function($event) {
          _vm.currentSlide = $index
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "filename"
    }, [_vm._v(_vm._s(image.name))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.images && _vm.images.length > 0) ? _c('div', {
    staticClass: "metadata col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Caption (one word) *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.images[_vm.currentSlide].descriptor),
      expression: "images[currentSlide].descriptor"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Example: wide, closeup, boots, head, gun",
      "type": "text"
    },
    domProps: {
      "value": (_vm.images[_vm.currentSlide].descriptor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.images[_vm.currentSlide].descriptor = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Discipline(s) *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discipline),
      expression: "discipline"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discipline = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.addDiscipline($event, _vm.currentSlide)
      }]
    }
  }, [_c('option', {
    attrs: {
      "default": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Select all that apply")]), _vm._v(" "), _vm._l((_vm.disciplines), function(discipline) {
    return _c('option', {
      attrs: {
        "disabled": _vm.images[_vm.currentSlide].disciplines.includes(discipline)
      }
    }, [_vm._v(_vm._s(discipline))])
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "disciplines"
  }, _vm._l((_vm.images[_vm.currentSlide].disciplines), function(discipline, $disciplineIndex) {
    return _c('li', [_vm._v("\n                        " + _vm._s(discipline) + "\n                        "), _c('div', {
      staticClass: "buttons"
    }, [_c('button', {
      staticClass: "remove-discipline",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeDiscipline($disciplineIndex)
        }
      }
    }, [_vm._v("x")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs apply-to-all",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.applyDisciplineToAll(discipline)
        }
      }
    }, [_vm._v("Apply to All")])])])
  }))])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9c7381d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/packages/coverflow/Coverflow.vue
// module id = 2086
// module chunks = 2